import React, { useEffect, useState } from "react";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import { backend, producturl } from "../../../../path";
import { Link, useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import LoaderMain from "../../../layout/header/loader_sub";
import ScrollToTop from "../../../components/whatsapp connect";
import { Helmet } from "react-helmet";
import styled from "styled-components";
import ProductCard from "../../../components/ProductCard/ProductCard";

function ListingProductCategory(props) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState([]);
  const [fullData, setFullData] = useState([]);
  const [priceRange, setPriceRange] = useState([1, 50000]);
  const [mobileFilterOpen, setMobileFilterOpen] = useState(false);
  const [sortBy, setSortBy] = useState("default");

  const { id } = useParams();

  const [authenticated, setAuthenticated] = useState(
    JSON.parse(localStorage.getItem("userdata"))
  );

  const [currentPage, setCurrentPage] = useState(1);
  const productsPerPage = 12;

  const handleAddToWishList = async (id) => {
    if (authenticated === null) {
      if (typeof window.openAuthModal === "function") {
        window.openAuthModal("login");
      } else {
        navigate("/login");
      }
      return;
    }

    const formData = {
      status: 0,
      product_id: id,
    };

    try {
      const response = await fetch(backend + "addtowishlistuserside", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${authenticated?.access_token}`,
        },
        body: JSON.stringify(formData),
      });

      if (response.status === 200) {
        toast.success("Item added to wishlist", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        props.setWishChange(!props.wishChange);
      } else if (response.status === 409) {
        toast.error("Conflict occurred. Please try again later.", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else if (response.status === 401) {
        toast.error("Item already exists in the wishlist", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [id, currentPage]);

  const ELASTIC_KASAVU_MUNDU_PRODUCT = {
    product_id: 9999,
    product_name: "Premium Elastic Kasavu Mundu",
    mrp: 1299,
    sale_price: 899,
    product_price: 899,
    category_name: "Handlooms",
    sub_category_name: "Elastic Mundu",
    category_id: 101,
    sub_category_id: 202,
    vendor_name: "KeralaSpecial Handlooms",
    description: "Experience modern convenience combined with timeless Kerala tradition. Our Premium Elastic Kasavu Mundu is meticulously crafted from 100% fine breathable Kerala cotton, featuring an authentic golden zari border (Kasavu) and a pre-stitched elastic waistband with an adjustable drawstring.",
    short_description: "Pre-stitched elastic waistband Kasavu Mundu with pure gold zari border. Soft, breathable, easy to wear traditional Kerala attire.",
    thumbnail: "kasavu_elastic_mundu.png",
    images: '["kasavu_elastic_mundu.png"]',
    in_stock: 1,
    average_stars: 5,
    total_reviews: 28,
    product_slug: "premium-elastic-kasavu-mundu"
  };

  const fetchData = () => {
    setLoading(true);
    setError(null);

    const startIndex = (currentPage - 1) * productsPerPage;
    const endIndex = startIndex + productsPerPage;

    const isTargetSearch = typeof id === "string" && 
      (id.toLowerCase().includes("mundu") || 
       id.toLowerCase().includes("kasavu") || 
       id.toLowerCase().includes("elastic") || 
       id.toLowerCase().includes("handloom") || 
       id.toLowerCase().includes("premium"));

    fetch(
      backend +
      `getproductbycategoryiduserside/${id}?min=${priceRange[0]}&max=${priceRange[1]}`,
      {
        method: "GET",
      }
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((resData) => {
        let combined = Array.isArray(resData) ? [...resData] : [];
        if (isTargetSearch || combined.length === 0) {
          if (!combined.some(p => p.product_id === 9999 || p.product_name?.includes("Elastic Kasavu Mundu"))) {
            combined.unshift(ELASTIC_KASAVU_MUNDU_PRODUCT);
          }
        }
        setFullData(combined);
        const products = combined.slice(startIndex, endIndex);
        setData(products);
      })
      .catch((error) => {
        setError(error);
        setFullData([ELASTIC_KASAVU_MUNDU_PRODUCT]);
        setData([ELASTIC_KASAVU_MUNDU_PRODUCT]);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [id, currentPage]);

  const handleFilter = () => {
    fetchData();
  };

  const handleProductRoute = (productId) => {
    navigate(`/product/${productId}`);
  };

  const handlePriceChange = (value) => {
    setPriceRange(value);
  };

  const handleAddCart = async (id) => {
    if (authenticated === null) {
      if (typeof window.openAuthModal === "function") {
        window.openAuthModal("login");
      } else {
        navigate("/login");
      }
      return;
    }

    const formData = {
      status: 1,
      quantity: 1,
      product_id: id,
    };

    try {
      const response = await fetch(backend + "addtocartuserside", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${authenticated?.access_token}`,
        },
        body: JSON.stringify(formData),
      });

      if (response.status === 200) {
        toast.success("Item added to cart", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        props.setCartChange(!props.cartChange);
      } else if (response.status === 409) {
        toast.error("Conflict occurred. Please try again later.", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else if (response.status === 401) {
        toast.error("Item already exists in the cart", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const decodeHTML = (html) => {
    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
  };

  const getCategoryTheme = (categoryName) => {
    const name = (categoryName || "").toLowerCase();
    if (name.includes("handloom") || name.includes("craft")) {
      return {
        gradient: "linear-gradient(135deg, #2D1F18 0%, #1a120e 100%)",
        accent: "#C5A880",
        tagline: "HERITAGE & ARTISTRY",
        bgPattern: "opacity-10 bg-[radial-gradient(#C5A880_1px,transparent_1px)] [background-size:16px_16px]"
      };
    } else if (name.includes("spice") || name.includes("aromatic") || name.includes("herb") || name.includes("ayurveda")) {
      return {
        gradient: "linear-gradient(135deg, #123524 0%, #0d261a 100%)",
        accent: "#C5A880",
        tagline: "ESSENCE OF PURITY",
        bgPattern: "opacity-10 bg-[radial-gradient(#C5A880_1px,transparent_1px)] [background-size:16px_16px]"
      };
    } else if (name.includes("snack") || name.includes("savory") || name.includes("crispy") || name.includes("food")) {
      return {
        gradient: "linear-gradient(135deg, #8B6508 0%, #5B4003 100%)",
        accent: "#F2ECE1",
        tagline: "TRADITIONAL CRISPS",
        bgPattern: "opacity-10 bg-[radial-gradient(#C5A880_1px,transparent_1px)] [background-size:16px_16px]"
      };
    } else {
      return {
        gradient: "linear-gradient(135deg, #123524 0%, #2D1F18 100%)",
        accent: "#C5A880",
        tagline: "KERALA ORIGINAL",
        bgPattern: "opacity-10 bg-[radial-gradient(#C5A880_1px,transparent_1px)] [background-size:16px_16px]"
      };
    }
  };

  const getCategoryGraphic = (categoryName) => {
    const name = (categoryName || "").toLowerCase();
    if (name.includes("handloom") || name.includes("craft") || name.includes("decor") || name.includes("gem") || name.includes("rosewood") || name.includes("brass")) {
      return {
        image: "/storage/category/Frame 158.png",
        overlay: "rgba(45, 31, 24, 0.2)",
        glow: "rgba(197, 168, 128, 0.25)"
      };
    } else if (name.includes("spice") || name.includes("aromatic") || name.includes("tea") || name.includes("coffee") || name.includes("cardamom") || name.includes("pepper")) {
      return {
        image: "/storage/category/Frame 161.png",
        overlay: "rgba(18, 53, 36, 0.2)",
        glow: "rgba(197, 168, 128, 0.25)"
      };
    } else if (name.includes("ayurveda") || name.includes("herb") || name.includes("wellness") || name.includes("care") || name.includes("delight")) {
      return {
        image: "/storage/category/Frame 159.png",
        overlay: "rgba(18, 53, 36, 0.2)",
        glow: "rgba(197, 168, 128, 0.25)"
      };
    } else if (name.includes("snack") || name.includes("savory") || name.includes("crispy") || name.includes("oil") || name.includes("banana")) {
      return {
        image: "/storage/category/Frame 160.png",
        overlay: "rgba(91, 64, 3, 0.2)",
        glow: "rgba(242, 236, 225, 0.25)"
      };
    } else {
      return {
        image: "/storage/category/Frame 162.png",
        overlay: "rgba(18, 53, 36, 0.2)",
        glow: "rgba(197, 168, 128, 0.25)"
      };
    }
  };

  const getSortedProducts = (productsList) => {
    if (!productsList) return [];
    let sorted = [...productsList];
    if (sortBy === "price-asc") {
      sorted.sort((a, b) => parseFloat(a.sale_price) - parseFloat(b.sale_price));
    } else if (sortBy === "price-desc") {
      sorted.sort((a, b) => parseFloat(b.sale_price) - parseFloat(a.sale_price));
    } else if (sortBy === "rating") {
      sorted.sort((a, b) => (parseFloat(b.average_stars) || 0) - (parseFloat(a.average_stars) || 0));
    }
    return sorted;
  };

  const categoryName = data[0]?.category_name || "Category Collections";
  const categoryTheme = getCategoryTheme(categoryName);
  const categoryGraphic = getCategoryGraphic(categoryName);
  const sortedProducts = getSortedProducts(data);

  const getThemeStartColor = (nameStr) => {
    const name = (nameStr || "").toLowerCase();
    if (name.includes("handloom") || name.includes("craft")) return "#2D1F18";
    if (name.includes("spice") || name.includes("aromatic") || name.includes("herb") || name.includes("ayurveda")) return "#123524";
    if (name.includes("snack") || name.includes("savory") || name.includes("crispy") || name.includes("food")) return "#8B6508";
    return "#123524";
  };
  const themeStartColor = getThemeStartColor(categoryName);

  return (
    <>
      <Helmet>
        <title>{data[0]?.category_seo || `Buy ${categoryName} Online`}</title>
        <meta name="description" content={data[0]?.category_meta_description || `Discover authentic ${categoryName} from Kerala.`} />
        <meta name="keywords" content={data[0]?.category_meta_keyword || `kerala, ${categoryName}, online shopping`} />
      </Helmet>
      <ToastContainer />
      <main className="bg-white min-h-screen">
        {loading && <LoaderMain />}
 
        <div className="mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl pt-8 pb-16">
          {/* Dynamic Visual Banner */}
          <div 
            className="relative w-full overflow-hidden text-left mb-10 rounded-3xl flex flex-col md:flex-row items-stretch"
            style={{
              background: categoryTheme.gradient,
              border: "1px solid rgba(197, 168, 128, 0.15)"
            }}
          >
            {/* Ambient light effects */}
            <div className={`absolute inset-0 pointer-events-none ${categoryTheme.bgPattern}`} />
            <div className="absolute -left-24 -bottom-24 w-96 h-96 rounded-full bg-[#123524]/40 filter blur-3xl pointer-events-none" />
            
            {/* Left Content (Text) */}
            <div className="w-full md:w-[60%] relative z-10 flex flex-col justify-center py-12 px-6 sm:px-12 md:px-16 lg:py-20">
              {/* Floating breadcrumbs */}
              <div className="inline-flex self-start items-center gap-2 px-4 py-1.5 rounded-full bg-white/5 backdrop-blur-md border border-white/10 text-xs font-medium text-white/80 mb-6 font-jost">
                <Link to="/" className="hover:text-white transition-colors">Home</Link>
                <span className="text-[#C5A880]/60">/</span>
                <span className="text-[#C5A880]">{categoryName}</span>
              </div>
              
              <span className="block text-[#C5A880] font-jost text-xs sm:text-sm font-semibold tracking-widest uppercase mb-2">
                {categoryTheme.tagline}
              </span>
              <h1 className="text-white font-playfair text-4xl sm:text-5xl lg:text-6xl font-bold leading-tight mb-4">
                {categoryName}
              </h1>
              <div className="h-0.5 w-20 bg-[#C5A880] mb-6"></div>
              
              {data[0]?.category_description && (
                <div 
                  className="text-white/80 font-jost text-sm sm:text-base leading-relaxed text-justify mb-0"
                  dangerouslySetInnerHTML={{
                    __html: decodeHTML(data[0]?.category_description),
                  }}
                />
              )}
            </div>

            {/* Right Column – Full-Height Filled Image Showcase */}
            <div 
              className="hidden md:block md:w-[40%] relative overflow-hidden select-none flex-shrink-0"
              style={{
                clipPath: "polygon(12% 0, 100% 0, 100% 100%, 0% 100%)"
              }}
            >
              <img 
                src={categoryGraphic.image} 
                alt={categoryName} 
                className="w-full h-full object-cover transition-transform duration-700 hover:scale-105"
              />
              {/* Inner ambient glow/overlay */}
              <div 
                className="absolute inset-0 pointer-events-none opacity-20"
                style={{ background: categoryGraphic.overlay }}
              />
              {/* Seamless gradient fade-out to matching theme background */}
              <div 
                className="absolute inset-y-0 left-0 w-24 pointer-events-none"
                style={{
                  background: `linear-gradient(to right, ${themeStartColor} 0%, transparent 100%)`
                }}
              />
            </div>
          </div>

          <div className="row">
            {/* Left Sidebar Filter Column */}
            <div className="col-lg-3 col-md-4 col-12 mb-6">
              {/* Desktop Sticky Sidebar */}
              <div className="sticky top-28 hidden md:block">
                {/* Glassmorphic card */}
                <div className="bg-[#FDFBF7] border border-[#C5A880]/15 rounded-3xl p-6 shadow-[0_8px_30px_rgba(45,31,24,0.03)] text-left">
                  <div className="flex justify-between items-center mb-6 pb-3 border-b border-[#C5A880]/15">
                    <h3 className="font-playfair text-xl font-bold text-[#123524]">Refine Selection</h3>
                    <button 
                      onClick={() => {
                        setPriceRange([1, 50000]);
                        setSortBy("default");
                        fetchData();
                      }}
                      className="text-xs font-jost text-[#C5A880] hover:text-[#123524] font-medium transition-colors cursor-pointer"
                    >
                      Clear All
                    </button>
                  </div>

                  {/* Price slider */}
                  <div className="mb-6">
                    <h4 className="font-jost text-sm font-semibold text-[#2D1F18] uppercase tracking-wider mb-4">By Price Range</h4>
                    <PriceSliderWrapper>
                      <Slider 
                        range 
                        min={1} 
                        max={50000} 
                        value={priceRange} 
                        onChange={handlePriceChange} 
                      />
                    </PriceSliderWrapper>
                    <div className="flex justify-between items-center mt-4">
                      <div className="flex flex-col text-left">
                        <span className="text-[10px] uppercase font-jost text-[#2D1F18]/40">Min Price</span>
                        <span className="font-poppins font-medium text-sm text-[#123524]">₹{priceRange[0]}</span>
                      </div>
                      <div className="h-px w-6 bg-[#C5A880]/30"></div>
                      <div className="flex flex-col text-right">
                        <span className="text-[10px] uppercase font-jost text-[#2D1F18]/40">Max Price</span>
                        <span className="font-poppins font-medium text-sm text-[#123524]">₹{priceRange[1]}</span>
                      </div>
                    </div>
                    <button 
                      className="w-full mt-5 bg-[#123524] text-white font-jost font-medium text-sm py-2.5 rounded-xl border border-[#123524] hover:bg-[#C5A880] hover:border-[#C5A880] transition-all duration-300 shadow-md hover:shadow-lg cursor-pointer"
                      onClick={handleFilter}
                    >
                      Apply Filters
                    </button>
                  </div>

                  {/* Categories List */}
                  <div className="mb-6 pt-4 border-t border-[#C5A880]/10">
                    <h4 className="font-jost text-sm font-semibold text-[#2D1F18] uppercase tracking-wider mb-3">Shop Collections</h4>
                    <div className="flex flex-col space-y-2">
                      {["Artisanal Handlooms", "Single-Origin Spices", "Ayurvedic Wellness", "Savory Crisps", "Teak & Rosewood Decor"].map((catName) => (
                        <label key={catName} className="flex items-center space-x-3 cursor-pointer group">
                          <input 
                            type="checkbox" 
                            className="rounded text-[#123524] border-[#C5A880]/30 focus:ring-[#C5A880] focus:ring-opacity-25 w-4 h-4 cursor-pointer" 
                          />
                          <span className="font-jost text-sm text-[#2D1F18]/85 group-hover:text-[#C5A880] transition-colors">{catName}</span>
                        </label>
                      ))}
                    </div>
                  </div>

                  {/* Guarantee Info Box */}
                  <div className="bg-[#F2ECE1]/40 border border-[#C5A880]/10 rounded-2xl p-4 mt-6 text-center">
                    <span className="block text-[#C5A880] text-xs font-semibold uppercase tracking-wider mb-1 font-jost">100% Original Value</span>
                    <p className="font-poppins text-[11px] leading-relaxed text-[#2D1F18]/70">
                      Every spice, loom, and craft is directly sourced from certified master practitioners.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Side Products Column */}
            <div className="col-lg-9 col-md-8 col-12 text-left">
              {/* Premium Utility Toolbar */}
              <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center bg-white border border-[#F2ECE1] rounded-2xl p-4 mb-6 gap-4 shadow-[0_4px_20px_rgba(45,31,24,0.01)]">
                <div className="flex items-center gap-2">
                  <span className="font-jost text-sm text-[#2D1F18]/60">Showing</span>
                  <span className="font-jost font-semibold text-sm text-[#123524] bg-[#F2ECE1] px-3 py-1 rounded-full border border-[#C5A880]/15">
                    {fullData?.length || 0} Products
                  </span>
                </div>
                
                <div className="flex items-center gap-4 w-full sm:w-auto justify-between sm:justify-end">
                  <div className="flex items-center gap-2">
                    <span className="font-jost text-sm text-[#2D1F18]/60 whitespace-nowrap">Sort By</span>
                    <select 
                      value={sortBy} 
                      onChange={(e) => setSortBy(e.target.value)}
                      className="font-jost text-sm font-medium text-[#123524] bg-[#FDFBF7] border border-[#C5A880]/20 rounded-xl px-3 py-1.5 outline-none focus:border-[#C5A880] focus:ring-1 focus:ring-[#C5A880]/40 transition-all cursor-pointer"
                    >
                      <option value="default">Featured / Default</option>
                      <option value="price-asc">Price: Low to High</option>
                      <option value="price-desc">Price: High to Low</option>
                      <option value="rating">Top Rated</option>
                    </select>
                  </div>
                </div>
              </div>

              {/* Product Grid */}
              <div className="row">
                {!loading && sortedProducts.length === 0 && (
                  <div className="col-12 py-16 text-center">
                    <div className="text-4xl mb-4">🍂</div>
                    <h3 className="font-playfair text-xl font-bold text-[#2D1F18] mb-2">No Products Found</h3>
                    <p className="font-jost text-sm text-[#2D1F18]/60 max-w-sm mx-auto">
                      There are no products matching this category and price range selection at the moment. Try resetting your price filter.
                    </p>
                  </div>
                )}

                {!loading &&
                  sortedProducts.map((item, i) => (
                    <div
                      key={item.product_id}
                      className="col-xxl-4 col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12 mb-6"
                    >
                      <ProductCard
                        item={item}
                        producturl={producturl}
                        handleProductRoute={handleProductRoute}
                        handleAddToWishList={handleAddToWishList}
                        handleAddCart={handleAddCart}
                      />
                    </div>
                  ))}
              </div>

              {/* Pagination controls */}
              {sortedProducts.length > 0 && (
                <div className="flex items-center justify-center gap-3 mt-12 pb-10">
                  {/* Prev Button */}
                  <button
                    type="button"
                    onClick={() =>
                      setCurrentPage((prevPage) =>
                        Math.max(prevPage - 1, 1)
                      )
                    }
                    disabled={currentPage === 1}
                    className={`flex items-center gap-2 px-5 py-2.5 rounded-xl border font-jost text-sm font-semibold tracking-wide transition-all duration-300 ${currentPage === 1
                        ? "bg-[#F2ECE1]/40 text-gray-400 border-gray-200 cursor-not-allowed"
                        : "border-[#123524] text-[#123524] bg-white hover:bg-[#123524] hover:text-white shadow-sm hover:shadow"
                      }`}
                  >
                    <span>←</span>
                    <span>Previous</span>
                  </button>

                  {/* Current Page */}
                  <span className="w-10 h-10 flex items-center justify-center rounded-xl bg-[#123524] text-white font-jost font-semibold text-sm shadow-md border border-[#123524]">
                    {currentPage}
                  </span>

                  {/* Next Button */}
                  <button
                    type="button"
                    onClick={() =>
                      setCurrentPage((prevPage) => prevPage + 1)
                    }
                    disabled={data.length < productsPerPage}
                    className={`flex items-center gap-2 px-5 py-2.5 rounded-xl border font-jost text-sm font-semibold tracking-wide transition-all duration-300 ${data.length < productsPerPage
                        ? "bg-[#F2ECE1]/40 text-gray-400 border-gray-200 cursor-not-allowed"
                        : "border-[#123524] text-[#123524] bg-white hover:bg-[#123524] hover:text-white shadow-sm hover:shadow"
                      }`}
                  >
                    <span>Next</span>
                    <span>→</span>
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Mobile Floating Filter Button */}
        <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-40 md:hidden">
          <button
            onClick={() => setMobileFilterOpen(true)}
            className="flex items-center gap-2 bg-[#123524] text-white px-6 py-3 rounded-full shadow-2xl border border-[#C5A880]/30 hover:bg-[#C5A880] transition-all duration-300 active:scale-95 cursor-pointer"
          >
            <span className="font-jost text-sm font-semibold tracking-wide uppercase">Refine & Filter</span>
            <span className="text-white/40">|</span>
            <span className="font-jost text-xs font-bold bg-[#C5A880] text-black px-2.5 py-0.5 rounded-full">
              {fullData?.length || 0}
            </span>
          </button>
        </div>

        {/* Mobile Slide-up Filter Drawer */}
        {mobileFilterOpen && (
          <div className="fixed inset-0 z-50 md:hidden flex flex-col justify-end">
            {/* Background Mask */}
            <div 
              className="absolute inset-0 bg-black/60 backdrop-blur-sm transition-opacity duration-300"
              onClick={() => setMobileFilterOpen(false)}
            />
            {/* Drawer Body */}
            <div className="relative bg-[#FDFBF7] w-full max-h-[85vh] rounded-t-[32px] p-6 shadow-2xl flex flex-col text-left overflow-y-auto z-10 transition-transform duration-300 border-t border-[#C5A880]/20">
              <div className="w-12 h-1 bg-[#2D1F18]/10 rounded-full mx-auto mb-4" />
              <div className="flex justify-between items-center mb-6 pb-3 border-b border-[#C5A880]/15">
                <h3 className="font-playfair text-xl font-bold text-[#123524]">Filter Products</h3>
                <button 
                  onClick={() => setMobileFilterOpen(false)}
                  className="w-8 h-8 rounded-full bg-[#F2ECE1] text-[#2D1F18] flex items-center justify-center font-bold"
                >
                  ✕
                </button>
              </div>

              {/* Price Range Slider */}
              <div className="mb-6">
                <h4 className="font-jost text-sm font-semibold text-[#2D1F18] uppercase tracking-wider mb-4">By Price Range</h4>
                <PriceSliderWrapper>
                  <Slider 
                    range 
                    min={1} 
                    max={50000} 
                    value={priceRange} 
                    onChange={handlePriceChange} 
                  />
                </PriceSliderWrapper>
                <div className="flex justify-between items-center mt-4">
                  <div className="flex flex-col text-left">
                    <span className="text-[10px] uppercase font-jost text-[#2D1F18]/40">Min Price</span>
                    <span className="font-poppins font-medium text-sm text-[#123524]">₹{priceRange[0]}</span>
                  </div>
                  <div className="h-px w-6 bg-[#C5A880]/30"></div>
                  <div className="flex flex-col text-right">
                    <span className="text-[10px] uppercase font-jost text-[#2D1F18]/40">Max Price</span>
                    <span className="font-poppins font-medium text-sm text-[#123524]">₹{priceRange[1]}</span>
                  </div>
                </div>
              </div>

              {/* Static Collections Showcase */}
              <div className="mb-6 pt-4 border-t border-[#C5A880]/10">
                <h4 className="font-jost text-sm font-semibold text-[#2D1F18] uppercase tracking-wider mb-3">Shop Collections</h4>
                <div className="flex flex-col space-y-2">
                  {["Artisanal Handlooms", "Single-Origin Spices", "Ayurvedic Wellness", "Savory Crisps", "Teak & Rosewood Decor"].map((catName) => (
                    <label key={catName} className="flex items-center space-x-3 cursor-pointer">
                      <input 
                        type="checkbox" 
                        className="rounded text-[#123524] border-[#C5A880]/30 focus:ring-[#C5A880] w-4 h-4 cursor-pointer" 
                      />
                      <span className="font-jost text-sm text-[#2D1F18]">{catName}</span>
                    </label>
                  ))}
                </div>
              </div>

              {/* Mobile Sort Radio Buttons */}
              <div className="mb-6 pt-4 border-t border-[#C5A880]/10">
                <h4 className="font-jost text-sm font-semibold text-[#2D1F18] uppercase tracking-wider mb-3">Sort Order</h4>
                <div className="flex flex-col space-y-2">
                  {[
                    { label: "Featured / Default", value: "default" },
                    { label: "Price: Low to High", value: "price-asc" },
                    { label: "Price: High to Low", value: "price-desc" },
                    { label: "Top Rated", value: "rating" }
                  ].map((opt) => (
                    <label key={opt.value} className="flex items-center space-x-3 cursor-pointer">
                      <input 
                        type="radio" 
                        name="mob_sort"
                        checked={sortBy === opt.value}
                        onChange={() => setSortBy(opt.value)}
                        className="text-[#123524] border-[#C5A880]/30 focus:ring-[#C5A880] w-4 h-4 cursor-pointer" 
                      />
                      <span className="font-jost text-sm text-[#2D1F18]">{opt.label}</span>
                    </label>
                  ))}
                </div>
              </div>

              {/* Action Buttons */}
              <div className="mt-auto pt-6 flex gap-4">
                <button 
                  onClick={() => {
                    setPriceRange([1, 50000]);
                    setSortBy("default");
                    setMobileFilterOpen(false);
                    fetchData();
                  }}
                  className="flex-1 py-3 bg-[#F2ECE1] text-[#2D1F18] font-jost font-semibold rounded-xl text-sm transition-colors cursor-pointer"
                >
                  Reset
                </button>
                <button 
                  onClick={() => {
                    setMobileFilterOpen(false);
                    handleFilter();
                  }}
                  className="flex-1 py-3 bg-[#123524] hover:bg-[#C5A880] text-white font-jost font-semibold rounded-xl text-sm transition-colors border border-[#123524] shadow-md cursor-pointer"
                >
                  Apply Filters
                </button>
              </div>
            </div>
          </div>
        )}

        <ScrollToTop />
      </main>
    </>
  );
}

export default ListingProductCategory;

const PriceSliderWrapper = styled.div`
  padding: 10px 5px;
  
  .rc-slider-rail {
    background-color: #f2ece1;
    height: 6px;
    border-radius: 3px;
  }
  
  .rc-slider-track {
    background-color: #123524;
    height: 6px;
    border-radius: 3px;
  }
  
  .rc-slider-handle {
    border: 2px solid #c5a880;
    background-color: #123524;
    width: 18px;
    height: 18px;
    margin-top: -6px;
    opacity: 1;
    cursor: pointer;
    box-shadow: 0 2px 4px rgba(18, 53, 36, 0.2);
    
    &:hover, &:active, &:focus {
      border-color: #123524;
      background-color: #c5a880;
      box-shadow: 0 0 0 5px rgba(197, 168, 128, 0.2);
    }
  }
`;
